import Vue from "vue";

import * as ModalDialogs from "vue-modal-dialogs";

Vue.use(ModalDialogs);
